<template>
  <div :id="$attrs['id']" :class="[$attrs['class']]" class="btn--more">
    <icon icon="fill-more" />
    <div class="btn--more__content">
      <slot />
    </div>
  </div>
</template>

<script>


export default {
  name: 'ButtonMore',

  mixins: [],

  props: {
  },

  computed: {

  },

  methods: {

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
   @import '~styles/import';
   .btn--more {
     width: 3rem;
     height: 3rem;
     display: block;
     position: relative;
     &:hover {
       cursor: pointer;
     }
     &__content {
      position: absolute;
      top: 100%;
      right: 0;
      background-color: $lightgray;
      border: 1px solid $gray;
      border-radius: 0.4rem;
      z-index: 10;
      opacity: 0;
      pointer-events: none;
      &__item {
        padding: 0.3rem 1.5rem;

      }
     }
   }
</style>



// WEBPACK FOOTER //
// src/components/lib/buttons/ButtonMore.vue